/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { usePictureInPictureCoordinator } from "./usePictureInPictureCoordinator";
